import React, {useContext, useRef} from 'react';
import {Platform, View} from "react-native";
import TitleM from "@common/components/text/TitleM";
import {theme} from "@common/theme/theme";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {connect} from "react-redux";
import {StatusBar} from "@common/systemBars/StatusBar";
import {PaginatedFlatList} from "@common/screens/PaginatedFlatList";
import {schoolsService} from "@data/services/schoolsService";
import {SchoolCard} from "./SchoolCard";

const Schools = (props) => {

    // ** Component props
    const {navigation, student, centerTitle} = props

    // console.log(student)

    // const request = !!student ? props.getStudentRequest : props.getUserRequest
    // const getUserService = !!student ? studentsService.getStudent : authService.getUser
    // const getUserParams = !!student ? {id: student?.id} : {}

    const requestApiService = schoolsService.getSchools

    // ** Manage scrolling to specific index in flat list
    const flatListRef = useRef()

    const schools = props.schools
    const dimensions = useContext(DimensionsContext)


    return <View style={{
        // backgroundColor: theme.colors.whiteAlmost,
        flex: 1
    }}>

        {<View style={{
            flex: 1,
            // backgroundColor: theme.colors.whiteAlmost,
            alignItems: 'center',
            alignSelf: "center"
        }}>
            <PaginatedFlatList data={schools}
                               ref={flatListRef}
                               style={{
                                   width: Platform.OS !== 'web' ? dimensions?.width : "100%"
                                   //backgroundColor: theme.colors.gemsLight

                               }}
                               contentContainerStyle={{
                                   alignItems: "center"
                               }}
                               additionalOnRefresh={() => {
                               }}
                               additionalRefreshing={false}
                               requestApiService={requestApiService}
                               requestRouteParams={{}}
                               requestUrlParams={null}
                               requestData={null}
                               ListHeaderComponent={<>
                                   <View style={{
                                       flexDirection: "row",
                                       alignItems: 'center',
                                       justifyContent: centerTitle ? 'center' : 'space-between',
                                       width: Platform.OS !== 'web' ? dimensions?.width : "100%", // borderBottomWidth: 1,
                                       borderColor: theme.colors.lightMore, // backgroundColor: theme.colors.accentLighter,
                                       paddingVertical: 15,
                                       paddingHorizontal: 10
                                       // marginBottom: 20
                                       // marginTop: 10
                                   }}>
                                       <TitleM fontWeight="ExtraBold">{"ÉCOLES"}</TitleM>
                                   </View>
                               </>}
                               renderItem={(item) => {
                                   return <SchoolCard school={item.item} key={item.index}/>
                               }}/>
            <StatusBar style="dark" backgroundColor={theme.colors.white} translucent={false}/>

        </View>}
    </View>
}

const mapStateToProps = state => {
    return {
        user: state.data.currentUser?.object,
        schools: state.data.schools?.list
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle
}

export default connect(mapStateToProps, mapDispatchToProps)(Schools)